import {useState} from "react";
import {IDateStartEndContext} from "@ui/datePicker/hooks/types/dateStartEnd";
import {getFistLastDay} from "@helpers/date";
import moment from "moment";
import {IInitialDateStartContextValue} from "@baseTypes/date/dateStartContext";

interface IProps extends IInitialDateStartContextValue {
    format?: string
}

const {firstDay, lastDay} = getFistLastDay()

export function useDateStartEndState({
                                         initialDateStart,
                                         initialDateEnd,
                                         format,
                                     }: IProps = {}): IDateStartEndContext {

    const [dateStart, setDateStart] = useState<string>(initialDateStart ?? moment(firstDay).format(format))
    const [dateEnd, setDateEnd] = useState<string>(initialDateEnd ?? moment(lastDay).format(format))

    return {
        dateStart, setDateStart,
        dateEnd, setDateEnd
    }
}